import React from 'react';
import { useParams } from 'react-router-dom';
import Header from './Header';
import FirmDetail from './FirmDetail';

/**
 * FirmDetailPage — the full-page /firm/:id route.
 * Thin wrapper: renders the shared <FirmDetail> (non-embedded) beneath the
 * global Header. All firm logic now lives in FirmDetail so the same view can
 * be embedded in the /firms master-detail pane.
 */
export default function FirmDetailPage() {
    const { id } = useParams();
    return (
        <div className="h-screen overflow-hidden bg-gray-50 flex flex-col">
            <Header />
            <div className="flex-1 min-h-0">
                <FirmDetail firmId={id} embedded={false} />
            </div>
        </div>
    );
}
